import { type GridColDef, type GridRenderCellParams } from "@mui/x-data-grid-pro";

import CoAppDataGridListCell from "../../../../global/components/datagrid/CoAppDataGridListCell";
import CoAppDataGridNameCell from "../../../../global/components/datagrid/CoAppDataGridNameCell";
import ThreeDotMenu from "../../../../global/components/ThreeDotMenu";

export const pluginGroupColumns = ["actions", "name", "users"];

export interface PluginGroupRow {
	id: string | number;
	name: string;
	users?: string[];
	[key: string]: unknown;
}

export const getPluginGroupsColumns = (
	handleOpenRemoveGroupConfirmDialog: (group: PluginGroupRow) => void
): GridColDef<PluginGroupRow>[] => [
	{
		field: "name",
		headerName: "Name",
		sortable: true,
		editable: false,
		flex: 1,
		renderCell: (params: GridRenderCellParams<PluginGroupRow>) => (
			<CoAppDataGridNameCell item={params.row} />
		)
	},
	{
		field: "users",
		headerName: "Users",
		editable: false,
		sortable: false,
		flex: 1,
		renderCell: (params: GridRenderCellParams<PluginGroupRow, string[] | undefined>) => (
			<CoAppDataGridListCell items={params.value} resource="Users" isUser={true} />
		)
	},
	{
		field: "actions",
		type: "actions",
		flex: .1,
		sortable: false,
		renderCell: (params: GridRenderCellParams<PluginGroupRow>) => (
			<div>
						<ThreeDotMenu
							options={[
								{
									name: "Remove",
									optionClickHandler: () => {
										handleOpenRemoveGroupConfirmDialog(params.row);
									}
								},
							]}
						/>
					</div>
		),
	},
];
